export type NewsCategory = '影视' | '综艺' | '音乐' | '网络' | '品牌' | '科技';

export interface NewsItem {
  id: string;
  date: string;
  time: string;
  title: string;
  summary: string;
  category: NewsCategory;
  source: string;
  heat: number;
  topicSlug: string;
  isTop: boolean;
}

export const newsList: NewsItem[] = [
  {
    id: 'n-20260910-01',
    date: '09-10',
    time: '09:24',
    title: '电影节红毯造型图集释出，两套礼服搭配成为讨论焦点',
    summary:
      '官方图集发布后，造型相关的对比图在社交平台快速流转，讨论集中在礼服配色与妆发风格的适配度上，主创团队暂未回应。',
    category: '影视',
    source: '星线文娱',
    heat: 9860,
    topicSlug: 'film-festival-red-carpet',
    isTop: true,
  },
  {
    id: 'n-20260910-02',
    date: '09-10',
    time: '09:02',
    title: '新剧开播首周评分出炉，观众对节奏处理意见分化',
    summary:
      '剧集开播一周后评分区间稳定在两极，支持者认为人物铺垫扎实，另一部分观众则认为前四集节奏偏缓，剧方回应称后续会加快。',
    category: '影视',
    source: '剧集观察室',
    heat: 8420,
    topicSlug: 'drama-premiere-review',
    isTop: true,
  },
  {
    id: 'n-20260910-03',
    date: '09-10',
    time: '08:47',
    title: '综艺新赛制上线，淘汰规则调整引发观众讨论',
    summary:
      '本季节目将投票权重从现场评审调整为线上线下各占一半，首期播出后讨论集中在规则是否对某类选手更有利。',
    category: '综艺',
    source: '综艺速递',
    heat: 7215,
    topicSlug: 'variety-show-rule-change',
    isTop: false,
  },
  {
    id: 'n-20260910-04',
    date: '09-10',
    time: '08:20',
    title: '音乐节阵容官宣，开票一分钟内多档票档售罄',
    summary:
      '主办方公布的阵容覆盖摇滚与独立流行两个方向，开票后有观众反映页面排队时间较长，主办方称正在扩容售票通道。',
    category: '音乐',
    source: '现场CUE',
    heat: 6980,
    topicSlug: 'music-festival-lineup',
    isTop: false,
  },
  {
    id: 'n-20260909-05',
    date: '09-09',
    time: '22:16',
    title: '品牌联名系列上线，线下快闪店排队情况被拍下',
    summary:
      '联名系列包含服饰与生活周边共十余款，上线当晚部分门店出现排队，品牌方发布限购说明，表示将补货。',
    category: '品牌',
    source: '消费前线',
    heat: 6640,
    topicSlug: 'brand-crossover-launch',
    isTop: false,
  },
  {
    id: 'n-20260909-06',
    date: '09-09',
    time: '21:03',
    title: '旗舰新机发布会结束，影像样张成对比热点',
    summary:
      '发布会重点介绍影像与续航，会后数码博主陆续放出实拍样张，讨论集中在夜景解析力与色彩倾向的取舍。',
    category: '科技',
    source: '数码头条',
    heat: 6320,
    topicSlug: 'phone-flagship-debut',
    isTop: false,
  },
  {
    id: 'n-20260909-07',
    date: '09-09',
    time: '19:41',
    title: '城市夜市排队风波后续：管理方公布分流方案',
    summary:
      '针对周末夜市排队时段过长的问题，管理方公布新的入场分流与限流方案，将于本周五起试行。',
    category: '网络',
    source: '城事记录',
    heat: 5110,
    topicSlug: 'city-night-market',
    isTop: false,
  },
  {
    id: 'n-20260909-08',
    date: '09-09',
    time: '17:28',
    title: '剧集片场路透流出，制片方呼吁不要干扰拍摄',
    summary:
      '一组非官方拍摄的路透图在网络流传，制片方发布说明，希望围观者与拍摄区域保持距离，避免影响正常进度。',
    category: '影视',
    source: '片场手记',
    heat: 4980,
    topicSlug: 'drama-premiere-review',
    isTop: false,
  },
  {
    id: 'n-20260909-09',
    date: '09-09',
    time: '15:52',
    title: '音乐节周边交通安排公布，接驳车线路增至六条',
    summary:
      '主办方联合当地交通部门公布接驳方案，新增夜间返程专线，并提示观众提前规划离场时间。',
    category: '音乐',
    source: '现场CUE',
    heat: 4360,
    topicSlug: 'music-festival-lineup',
    isTop: false,
  },
  {
    id: 'n-20260909-10',
    date: '09-09',
    time: '14:09',
    title: '联名系列二级市场价格波动，官方提醒理性消费',
    summary:
      '部分热门单品在二手平台出现加价现象，品牌方在社交账号提醒消费者通过官方渠道购买，谨防仿品。',
    category: '品牌',
    source: '消费前线',
    heat: 4020,
    topicSlug: 'brand-crossover-launch',
    isTop: false,
  },
  {
    id: 'n-20260909-11',
    date: '09-09',
    time: '11:37',
    title: '综艺嘉宾阵容补位公布，节目组回应换人原因',
    summary:
      '节目组确认两位常驻嘉宾因档期调整退出，由新嘉宾补位，并说明后续剧情走向不会受明显影响。',
    category: '综艺',
    source: '综艺速递',
    heat: 3890,
    topicSlug: 'variety-show-rule-change',
    isTop: false,
  },
  {
    id: 'n-20260909-12',
    date: '09-09',
    time: '09:15',
    title: '新机预售页面开放，首批备货量与配色分布公布',
    summary:
      '官方公布了各配色的首批备货比例，并开放预售通道，其中主打配色在部分渠道显示为首批售罄状态。',
    category: '科技',
    source: '数码头条',
    heat: 3540,
    topicSlug: 'phone-flagship-debut',
    isTop: false,
  },
  {
    id: 'n-20260908-13',
    date: '09-08',
    time: '20:44',
    title: '红毯造型争议延烧：造型团队发布设计思路说明',
    summary:
      '造型团队在社交账号发布设计手稿与配色说明，解释礼服选型依据，并表示尊重不同审美意见。',
    category: '影视',
    source: '星线文娱',
    heat: 5120,
    topicSlug: 'film-festival-red-carpet',
    isTop: false,
  },
  {
    id: 'n-20260908-14',
    date: '09-08',
    time: '16:21',
    title: '夜市管理方回应排队问题，将增设临时引导岗位',
    summary:
      '管理方称已关注到周末高峰时段的排队情况，将在入口增设引导岗位并优化动线，后续视效果调整。',
    category: '网络',
    source: '城事记录',
    heat: 3180,
    topicSlug: 'city-night-market',
    isTop: false,
  },
  {
    id: 'n-20260908-15',
    date: '09-08',
    time: '10:08',
    title: '剧方发布第二版预告，叙事重心转向配角线',
    summary:
      '新预告把镜头更多给了配角群像，被解读为对首周讨论的回应，剧方表示预告只是剪辑呈现，不影响正片结构。',
    category: '影视',
    source: '剧集观察室',
    heat: 2960,
    topicSlug: 'drama-premiere-review',
    isTop: false,
  },
];

export const hotRanking = [
  { rank: 1, title: '电影节红毯造型争议持续，造型团队发说明', heat: 9860, topicSlug: 'film-festival-red-carpet' },
  { rank: 2, title: '新剧首周评分分化，剧方回应节奏问题', heat: 8420, topicSlug: 'drama-premiere-review' },
  { rank: 3, title: '综艺新赛制上线，投票权重调整引讨论', heat: 7215, topicSlug: 'variety-show-rule-change' },
  { rank: 4, title: '音乐节阵容官宣，多档票一分钟售罄', heat: 6980, topicSlug: 'music-festival-lineup' },
  { rank: 5, title: '品牌联名上线，快闪店排队画面流出', heat: 6640, topicSlug: 'brand-crossover-launch' },
  { rank: 6, title: '旗舰新机发布，影像样张成对比焦点', heat: 6320, topicSlug: 'phone-flagship-debut' },
];